module.exports = __webpack_public_path__ + "9b3e55db632ab404b5b8918067f161b6.pdf";